import { getAllTaproomLocationLabels } from '../brewery/getBeerLocationLabels';

export interface PortfolioBeerListingSource {
  breweryId?: string;
  availableBreweryIds?: string[];
}

/**
 * Full taproom labels for pint portfolio beer cards and profile "Listed at" sections.
 */
export function getPortfolioBeerListingLabels(
  beer: PortfolioBeerListingSource,
  breweryNameById: Record<string, string>,
): string[] {
  return getAllTaproomLocationLabels(beer, breweryNameById).map((row) => row.label);
}
